'use client';
import React, { useState } from 'react';
import Image from 'next/image';
import ShareMemoriesModal from '../ui/ShareMemoriesModal';

const Memories = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isButtonHovered, setIsButtonHovered] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
  
      <div className="bg-[#F4FBFB] pt-6 pb-16 px-8 md:px-12">
      <hr style={{ borderColor: '#ACD2D2', borderWidth: '1px', marginBottom:'40px'}} />

      <div className="text-center md:px-4 max-w-8xl mx-auto">
        <div className="flex justify-center mb-4">
          <div className="w-11 h-11  rounded-full flex items-center justify-center mt-2">
          <Image src="/shareupdated.svg" alt="Share" width={24} height={24} className="w-12 h-12 object-contain mb-2"  />
          </div>
        </div>

        <h1 id="intro-heading" className="text-2xl md:text-4xl uppercase text-[#005E60] font-extrabold mb-4" >
          Share Your Memories
        </h1>

        <p className="text-black text-lg max-w-4xl mx-auto mb-12  opacity-90 leading-tight">
          GE Vernova has long been part of the fabric of Peterborough, with deep roots set down over decades. While long-term plans for commemorating the site’s role in the community are still under consideration, GE Vernova would like to hear from you.
        </p>

        {/* Full-width image grid with overlay */}
        <div className="relative w-screen left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] max-w-none">
          <div className="grid grid-cols-4 md:gap-0 opacity-100 h-[150px] md:h-[500px]">
            <div className="overflow-hidden w-full pr-16 md:pr-0">
              <Image
                src="/memory11.png"
                alt="Memory 1"
                width={300}
                height={200}
                className="object-cover h-full w-[200%] -ml-[4%] rounded-md md:rounded-lg"
              />
            </div>
            <div className='overflow-hidden -ml-16 md:-ml-0 mr-[2px] md:mr-2'>
              <Image src="/memory2.png" alt="Memory 2" width={300} height={200} className="rounded-md md:rounded-lg h-full w-full"/>
            </div>
            <div className='overflow-hidden -mr-16 md:-mr-0 ml-[2px] md:ml-2'>
            <Image src="/memory3.png" alt="Memory 3" width={300} height={200} className="rounded-md md:rounded-lg h-full w-full" />
            </div>
            <div className="overflow-hidden w-full pl-16 md:pl-0">
              <Image
                src="/memory44.png"
                alt="Memory 4"
                width={300}
                height={200}
                className="object-cover h-full w-[200%] ml-[4%] rounded-md md:rounded-lg"
              />
            </div>
          </div>

          <div id="memories" className="relative pb-[350px] md:pb-0">
            <div className="absolute inset-x-0 top-0 flex justify-center items-center">
              <div
                className="
                  bg-white rounded-xl md:shadow-xl p-10 max-w-md w-[90%] md:w-full z-10 text-center -mt-16  md:absolute md:-mt-[500px]
                "
              >
                <h2 className="text-2xl text-[#005E60] mb-4 block md:hidden">
                  How has the site <br /> helped shape the community?
                </h2>
                <h2 className="text-2xl text-[#005E60] mb-4 hidden md:block">
                  How has the site helped shape the community?
                </h2>
                <p className="text-black mb-6 text-sm opacity-90">
                  If you have a story, photo, or recollection, GE Vernova invites
                  you to share it.
                </p>
                <button 
                  onClick={openModal}
                  onMouseEnter={() => setIsButtonHovered(true)}
                  onMouseLeave={() => setIsButtonHovered(false)}
                  className="bg-[#C8FF08] hover:bg-[#002D2E] text-[#005E60] hover:text-white font-bold pt-2 pb-2 pr-2 pl-6 rounded-full text-sm md:text-md  transition duration-300 flex items-center justify-center gap-3 mx-auto cursor-pointer">
                  Send GE Vernova your memories
                  <span className="w-8 h-8 rounded-full flex items-center justify-center text-lg">
                    {isButtonHovered ? (
                      <Image src="/Arrow_hover.svg" alt="Arrow" width={50} height={50} />
                    ) : (
                      <Image src="/arrow.svg" alt="Arrow" width={50} height={50} />
                    )}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    
    <ShareMemoriesModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default Memories;
